import React from 'react'
import Heading from '../../../../components/Heading'
import Text from '../../../../components/Text'
import { useTranslation } from 'react-i18next'
import { useIndividualizationContext } from '../../../../contexts/individualizationContext'
import TemplateCard from './TemplateCard'
import cx from 'classnames'
import styles from './UploadTemplates.module.css'
import NewTemplateCard from './NewTemplateCard'

const UploadTemplates: React.FC = () => {
    const { t } = useTranslation(['individualization'])
    const { activeStep, templates } = useIndividualizationContext()

    return activeStep === 1 ? (
        <>
            <Heading level={3} classes={'zr-mt-4'}>
                {t('progress.upload_templates')}
            </Heading>
            <Text classes={'zr-my-4'}>{t('upload_templates.description')}</Text>
            <div className={cx(styles['card-list'])}>
                <NewTemplateCard />
                {templates.map((template) => {
                    return <TemplateCard key={template.id} {...template} />
                })}
            </div>
        </>
    ) : null
}

export default UploadTemplates
